"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function showIntoView() {
    const showDivs = document.getElementsByClassName("now");
    const timeList = [];
    for (let i = 0; i < showDivs.length; i++) {
        const t = setTimeout(() => {
            if (showDivs && showDivs.length > 0 && showDivs[i]) {
                showDivs[i].scrollIntoView({ block: "center", inline: "center" });
            }
        }, 1);
        timeList.push(t);
    }
    return () => {
        for (let i = 0; i < timeList.length; i++) {
            clearTimeout(timeList[i]);
            timeList[i] = null;
        }
    };
}
exports.default = showIntoView;
